import {useQuery, gql} from "@apollo/client";

var  FOOTER_SOCIAL_MEDIA = gql`
query FooterSocialMedia {
    footerSocialMedia(where: {localization: {culture_starts_with: "fa"}}) {
      id
      htmlBody {
        html
      }
    }
  }
`;

export const useSocialMedia = () => {
  const {error, loading, data} = useQuery(FOOTER_SOCIAL_MEDIA);
  
  return {
    error, data, loading
  };
  } 